const GET_CEMEX_TRACKING_ORDERS_REQUEST = 'GET_CEMEX_TRACKING_ORDERS_REQUEST';
const GET_CEMEX_TRACKING_ORDERS_SUCCESS = 'GET_CEMEX_TRACKING_ORDERS_SUCCESS';
const GET_CEMEX_TRACKING_ORDERS_ERROR = 'GET_CEMEX_TRACKING_ORDERS_ERROR';

const CLEAR_CEMEX_TRACKING_ORDERS_STATE = 'CLEAR_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_CEMEX_TRACKING_ORDERS_REQUEST,
  GET_CEMEX_TRACKING_ORDERS_SUCCESS,
  GET_CEMEX_TRACKING_ORDERS_ERROR,
  CLEAR_CEMEX_TRACKING_ORDERS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  INIT_REDUCER,
};
